import { createSlice } from '@reduxjs/toolkit';
import apolloClient from '../queries';
import { FetchLands } from '../queries/index.graphql';
import { getHotelState, getFlightState, saveSelectedPlanOptions, getSelectedPlanOptionsState } from '../utils/localStorage';
import { sessionKey } from './app';
import { makeLandInput } from '../utils/input';
import { history } from '../utils/history';

const initialState = {
  fetching: false,
  planOptions: [],
  selectedPlanOptions: [],
};

const planOptionSlice = createSlice({
  name: 'land',
  initialState,
  reducers: {
    setFetchingPlanOptions: {
      reducer(state, action) {
        const { fetching } = action.payload;
        state.fetching = fetching;
      },
      prepare(fetching) {
        return { payload: { fetching } };
      }
    },
    setPlanOptions: {
      reducer(state, action) {
          const { planOptions } = action.payload;
          state.planOptions = planOptions;
      },
      prepare(planOptions) {
          return { payload: { planOptions } };
      }
    },
    setSelectedPlanOptions: {
      reducer(state, action) {
          const { selectedPlanOptions } = action.payload;
          state.selectedPlanOptions = selectedPlanOptions;
          saveSelectedPlanOptions(sessionKey, selectedPlanOptions);
      },
      prepare(selectedPlanOptions) {
          return { payload: { selectedPlanOptions } };
      }
    },
  },
});

export const {
  setFetchingPlanOptions,
  setPlanOptions,
  setSelectedPlanOptions,
} = planOptionSlice.actions;

// Landクエリを実行する
export const fetchPlanOptions = (landsInput) => async (dispatch) => {
  dispatch(setFetchingPlanOptions(true));

  try {
    const { data } = await apolloClient.query({
      query: FetchLands,
      variables: {
        input: landsInput,
      },
      fetchPolicy: 'no-cache',
    });

    const {
      lands,
    } = data;

    dispatch(setPlanOptions(lands));

  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);

    //エラーメッセージを表示する
    let messages = [];
    if (error && error.graphQLErrors && error.graphQLErrors.length) {
      messages = error.graphQLErrors.map((e) => (e.debugMessage || e.message)).filter(Boolean);
    }
    history.push({ pathname: '/error', state: { m: messages.join(', ') } });
  } finally {
    dispatch(setFetchingPlanOptions(false));
  }
};

export const handleQueryParamsPlanOption = (queryParams) => (dispatch) => {
  const { p, rt, k } = queryParams;
  const hotelState = getHotelState(k);
  const { searchedHotelsInput } = hotelState;
  const flightState = getFlightState(k);
  const { searchedFlightsInput } = flightState;
  const { selectedOutboundFlight } = flightState;

  const landInput = makeLandInput(p, rt, searchedHotelsInput, searchedFlightsInput, selectedOutboundFlight);

  if (landInput) {
    dispatch(fetchPlanOptions(landInput));
  }
};

export default planOptionSlice.reducer;